@if (currentUser$ | async; as currentUser) {
    <div class="customer-selection-wrapper">
        @if (currentUser.availableUnits.length > 1 || currentUser.tukkumyyja) {
            <button
                class="current-customer link"
                [tabIndex]="0"
                role="button"
                attr.aria-label="{{ 'aimo.b2bunit.dropdown.arialLabel' | cxTranslate }}"
                (click)="toggleVisible()"
            >
                <i class="aimo-icon icon-sm icon-white icon-buildings mr-2 d-lg-inline-block d-none"></i>
                <i class="aimo-icon icon-petrol-blue icon-buildings mr-2 d-lg-none d-inline-block"></i>
                <span
                    [ngClass]="{ 'name-short': showMyAssortment$ | async }"
                    placement="bottom"
                    container="body"
                    triggers="mouseenter:mouseleave"
                    [ngbPopover]="currentUser?.unit?.uid + ' ' + currentUser?.unit?.name"
                    popoverClass="popover-md"
                >{{ currentUser?.unit?.uid }} {{ currentUser?.unit?.name }}</span
                >
                <i
                    class="aimo-icon icon-sm icon-white ml-2 d-lg-inline-block d-none"
                    [class.icon-caret-down]="!visible"
                    [class.icon-caret-up]="visible"></i>
                <i
                    class="aimo-icon icon-petrol-blue ml-2 d-lg-none d-inline-block float-right"
                    [class.icon-caret-down]="!visible"
                    [class.icon-caret-up]="visible"></i>
            </button>
        } @else {
            <div class="current-customer">
                <span>{{ currentUser?.unit?.uid }} {{ currentUser?.unit?.name }}</span>
            </div>
        }
        @if (visible) {
            <div class="customer-selection">
                @let isMobileApp = isMobileApp$ | async;
                @if (!isMobileApp) {
                    <cx-page-slot position="SearchUnits"></cx-page-slot>
                }
                <div class="results" id="results" role="dialog"></div>
                @if (!currentUser.tukkumyyja) {
                    <div
                        class="my-results"
                        id="my-results"
                        role="dialog"
                        (keydown.escape)="closeDropdown()">
                        <div class="customer-header">{{ 'aimo.b2bunit.results.header' | cxTranslate }}</div>
                        <ul class="b2bunits" role="listbox">
                            @for (b2bUnit of currentUser.availableUnits; track b2bUnit.uid; let idx = $index) {
                                <li
                                    [ngClass]="{ 'credit-card-user': !b2bUnit.allowInvoices }"
                                    [attr.aria-label]="'aimo.arialLabel.customer.dropdown' | cxTranslate: { customer: b2bUnit.name }">
                                    <button
                                        [id]="'customer_select_' + idx"
                                        (keydown.arrowDown)="nextFocus($event, idx, currentUser.availableUnits.length)"
                                        (keydown.arrowUp)="previousFocus($event, idx)"
                                        (mouseenter)="setFocus(idx)"
                                        class="unit-button"
                                        (click)="selectUnit(b2bUnit.uid, currentUser)">
                                        <div class="unit-number">
                                            <div>{{ b2bUnit.uid }}</div>
                                            @if (!b2bUnit.allowInvoices) {
                                                <i class="aimo-icon icon-credit-card icon-sm icon-red"></i>
                                            }
                                        </div>
                                        <div class="unit-name" (click)="selectUnit(b2bUnit.uid, currentUser)">
                                            <div class="text-bold" [innerHTML]="b2bUnit.name"></div>
                                            @if (b2bUnit.addresses?.length > 0) {
                                                <div [innerHTML]="b2bUnit.addresses[0].line1"></div>
                                                <div>
                                                    <div
                                                        class="d-inline-block mr-1"
                                                        [innerHTML]="b2bUnit.addresses[0].postalCode"></div>
                                                    <div class="d-inline-block"
                                                         [innerHTML]="b2bUnit.addresses[0].town"></div>
                                                </div>
                                            }
                                        </div>
                                    </button>
                                </li>
                            }
                        </ul>
                    </div>
                }
            </div>
        }
    </div>
}
